import type { PriceDaily, RMR } from "epsm-api-types/models";

export interface Stock {
	Date: Date;
	Symbol: string;
	Close: number;
	value: number;
}

export type SectorsType =
	| "XLB"
	| "XLC"
	| "XLE"
	| "XLF"
	| "XLI"
	| "XLK"
	| "XLP"
	| "XLRE"
	| "XLU"
	| "XLV"
	| "XLY";

export type Sectors = {
	readonly [t in SectorsType]: {
		readonly ticker: string;
		readonly name: string;
		readonly color: string;
	};
};

export enum SectorsTimeRange {
	OneYear = "1Y",
	SixtyDays = "60D",
	FifteenDays = "15D",
}
export type SectorsChartType = "Price" | "Ratio";

export type TimeRangeInfo = {
	fields: (keyof PriceDaily)[];
	rmrFields?: (keyof RMR)[];
	rmrClosePrice: "index_ratio";
	requestPath: string;
	isIntraday: boolean;
	duration: number;
	closePrice: "adj_close" | "close";
	xAxisStep: number;
	dataFormat: "%m/%d/%y %I:%M %p" | "%m/%d/%y";
	tooltipWidth: number;
};
